module.exports = "/_next/static/images/sprite.icons-0acfb16551c4e83dc0b5d14eef095c8a.svg";